import React, { Component } from "react";
import {
  getRowColumns,
  getRowOptions,
  saveRow,
} from "../../../services/formService";
import CustomLoader from "../../common/Loader";
import * as Icon from "react-feather";
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../config';
import { logActivity } from '../../../services/utilService';

class WRow extends Component {
  state = {
    Widget_ID: this.props.Widget.Widget_ID,
    Form_ID: this.props.Form_ID,
    Columns: [],
    Options: [],
    loading: true,
  };

  constructor(props) {
    super(props);
    this.handleAddColumn = this.handleAddColumn.bind(this);
    this.handleRemoveColumn = this.handleRemoveColumn.bind(this);
    this.handleColumnSelect = this.handleColumnSelect.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  async componentDidMount() {
    const { data: Options } = await getRowOptions(this.props.Form_ID);
    (Options).filter(el => el.Widget_Type_ID === 2 && (el['Display_Name'] = el['Display_Name'].replace(/(<([^>]+)>)/ig, '')))
    this.setState({ Options });

    const { data: Columns } = await getRowColumns(this.state.Widget_ID);
    this.setState({ Columns });

    this.setState({ loading: false });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.refresh !== this.props.refresh && this.props.refresh) {
      const { data: Options } = await getRowOptions(this.props.Form_ID);
      (Options).filter(el => el.Widget_Type_ID === 2 && (el['Display_Name'] = el['Display_Name'].replace(/(<([^>]+)>)/ig, '')))
      this.setState({ Options });

      const { data: Columns } = await getRowColumns(this.state.Widget_ID);
      this.setState({ Columns });
      this.props.refreshRowWidget()
    }
  }

  handleAddColumn = () => {
    let Columns = [
      ...this.state.Columns,
      {
        Column_ID: 0,
        Column_Widget_ID: 0,
        Column_Widget_Type_ID: 0,
        Form_ID: this.state.Form_ID
      },
    ];
    this.setState({ Columns });
  };

  handleRemoveColumn = (idx) => {
    const Columns = [...this.state.Columns];
    Columns.splice(idx, 1);
    this.setState({ Columns });
  };

  handleColumnSelect = (wID, idx) => {
    let Columns = [...this.state.Columns];
    Columns[idx].Column_Widget_ID = parseInt(wID);
    Columns[idx].Column_Widget_Type_ID = parseInt((this.state.Options).filter(el => el.Widget_ID === parseInt(wID) )[0].Widget_Type_ID);
    Columns[idx].Form_ID = this.state.Form_ID;
    this.setState({ Columns });
  };

  handleSave = async () => {
    const { data } = await saveRow(this.state);

    if (data.includes("Error")) {
      toaster('error', data);
      logActivity('/formBuilder','WIDGET_ROW_SAVE_FAILED');
    } else {
      toaster('success', data);
      logActivity('/formBuilder','WIDGET_ROW_SAVE_SUCCESS');
    }
  };

  handleRemove = () => {
    this.props.onRemove(this.state.Widget_ID);
  };

  render() {
    if (this.state.loading) {
      return <CustomLoader loading={this.state.loading} />;
    }

    const { Columns, Options, Widget_ID } = this.state;

    return (
      <React.Fragment>
        <ul className="list-group list-group-flush">
          {Columns.map((col, idx) => (
            <li
              className="list-group-item d-flex justify-content-between aligh-items-center"
              key={Widget_ID + "RowCol" + idx}
            >
              <div className="input-group input-group-joined mr-1">
                <div className="input-group-prepend">
                  <span className="input-group-text">Column {idx + 1}</span>
                </div>
                <select
                  name={Widget_ID + "selectCol" + idx}
                  key={Widget_ID + "SelectCol" + idx}
                  value={col.Column_Widget_ID}
                  className="form-control"
                  onChange={(e) => this.handleColumnSelect(e.target.value, idx)}
                >
                  <option value="0"> - Select -</option>
                  {Options.map((option) => (
                    <option
                      value={option.Widget_ID}
                      // key={
                      //   Widget_ID + "ColOptions" + idx + "-" + option.Widget_ID
                      // }
                    >
                      {(option.Display_Name).toString()}
                    </option>
                  ))}
                </select>
              </div>

              <button
                className="btn btn-outline-danger btn-sm"
                onClick={() => this.handleRemoveColumn(idx)}
              >
                X
              </button>
            </li>
          ))}
        </ul>

        {Columns.length < 12 && (
          <div className="text-center mt-1">
            <button
              className="btn btn-outline-primary btn-icon btn-sm"
              onClick={this.handleAddColumn}
            >
              <Icon.Plus size={18} />
            </button>
          </div>
        )}

        <div className="d-flex justify-content-end">
          <button
            className="btn btn-outline-primary mr-2"
            onClick={this.handleSave}
          >
            Save
          </button>
          <button
            className="btn btn-outline-danger"
            onClick={this.handleRemove}
          >
            Delete
          </button>
        </div>
        <ToastContainer/>
      </React.Fragment>
    );
  }
}

export default WRow;
